import api from "./core/api";
class Member {
    constructor(api) {
        this.api = api;
    }
    member(options = {}) {
        return this.api.client.get(
            this.api.getUrl('member'), options
        );
    }
    cmlxBalance(options = {}) {
        return this.api.client.get(
            this.api.getUrl('member/cmlx/balance'), options
        );
    }
    itwBalance(options = {}) {
        return this.api.client.get(
            this.api.getUrl('member/cmlx/balance/itw'), options
        );
    }
    ticketBalance(options = {timeout: 60000}) {
        return this.api.client.get(
            this.api.getUrl('member/experience-ticket/balance'), options
        );
    };
    points(options = {}) {
        return this.api.client.get(
            this.api.getUrl('member/points'), options
        );
    }
    legalInfo(options = {}) {
        return this.api.client.get(
            this.api.getUrl('member/legal-info'), options
        );
    }
    sysBalance(options = {}) {
        return this.api.client.get(
            this.api.getUrl('member/cmlx/balance/wallet'), options
        );
    }
    is3DBuildingExists(options = {}) {
        return this.api.client.get(
            this.api.getUrl('member/assets/has3DPremiumBuilding'), options
        );
    }
    getAbeyTansferForm() {
        return this.api.client.get(
            this.api.getUrl('member/abey-balance/transfer/private/from-wallet')
        );
    }
    setAbeyTansfer(amount, options = {}) {
        return this.api.client.post(
            this.api.getUrl('member/abey-balance/transfer/private/from-wallet'),
            {json: {amount: amount}, options}
        );
    }
    setOwnerId(ownerId, options) {
        return this.api.client.post(
            this.api.getUrl('member/owner-id'),
            {...options,  json: {ownerId} }
        );
    }
    getFoundersPlanIsVisible() {
        return this.api.client.get(
            this.api.getUrl('member/purchase/list?perPage=1&filter[productId]=1,2,3,4&filter[status]=1&filter[dateEnd]=2024-01-01T06:00:00.000000Z')
        ).then(resp => resp.json()).then(({data}) => {
            return data.length > 0;
        }).catch(() => false);
    }
    virtualBuildingExists(options = {}) {
        return this.api.client.get(
            this.api.getUrl('member/virtual-building/exists'), options
        );
    }
}

export default (new Member(api))
